// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__3GTnl","footer":"ChangeClinic_footer__1BLmD"};